import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './action';
import { getDataFromBOU } from '../../Helpers/ApiMethodHelper';
function* getClientDataResponse() {
  try {
    const response = yield call(getDataFromBOU, `https://auth-tsp-dashboard.plutos.one/v1/organizations`);
      yield put(actions.getClientDataSuccess(response?.data));
    
  } catch (error) {
    yield put(actions.getClientDataFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.GET_CLIENT_DATA, getClientDataResponse)]);

}
